import { Messages } from '~src/codegen/Localize';
import { ContentTypeFilterClause,ExplorableItemDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { DataAlerts } from '~src/dda/resources/DataAlerts';
import { GenericCard } from '~src/spacesPlatform/components/card/GenericCard';
import { DataAlertContentType } from '~src/spacesPlatform/models/ContentTypes';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';

import { getGenericDefaultFilters } from '../../contentDefinitions/getDefaultFilters';

export const DataAlertDefinition: ExplorableItemDefinition = {
  itemType: 'dataalert',
  pluralName: Messages.dataAlerts,
  singularName: Messages.dataAlert,
  emptyStateMessage: Messages.dataAlertsEmptyMessage,
  contentFilterKeys: DataAlertContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: ServerFilterClauses.ContentType(['dataalert']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return DataAlerts.all().withExtraParams(DataAlertContentType.extraQueryParams);
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list'],
};
